export enum OrderOfferType {
  Tier = 1,
  Pool,
  PrePay,
  Other
}
